/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BodyCreateProjectApiProjectsPostAccessLevel } from './bodyCreateProjectApiProjectsPostAccessLevel';

export interface BodyCreateProjectApiProjectsPost {
  /**
     * @minLength 1
     * @maxLength 255
     */
  title: string;
  description?: string | null;
  access_level?: BodyCreateProjectApiProjectsPostAccessLevel;
  collaborator_ids?: string[];
  cover?: Blob | null;
}
